import PageData from '../../PageData';
import {getChatSectionsMap} from '../../ChatSections';

export default class SocialTab {
  private pageData: PageData;

  private socialForm: HTMLElement;

  private multipleSocialNetworks: HTMLElement;

  private readonly socialTabMessage: HTMLElement;

  private submitSocialTabForm: HTMLInputElement;

  private chatSections = getChatSectionsMap();

  private socialTabChatButtonsIds = [
    'social-tab-list-whatsapp',
    'social-tab-list-line',
    'social-tab-list-messenger',
    'social-tab-list-viber',
    'social-tab-list-skype',
    'social-tab-line',
    'social-tab-messenger',
    'social-tab-viber',
    'social-tab-skype',
  ];

  constructor(pageData: PageData) {
    this.socialForm = document.querySelector('div[data-element=\'social-tab-form\']')! as HTMLElement;
    this.multipleSocialNetworks = document.getElementById('social-tab-many-networks')!;
    this.socialTabMessage = document.getElementById('email-inquiry-modal-message')!;
    this.submitSocialTabForm = document.getElementById('submit-button-chat-options')! as HTMLInputElement;
    this.pageData = pageData;
  }

  public setupEventListeners = () => {
    this.socialTabChatButtonsIds.forEach((itemId) => {
      const element = document.getElementById(itemId);
      if (element) element.addEventListener('click', this.showSocialTabContactForm);
    });
  };

  public showSocialTabContactForm = (event: Event) => {
    let clickedButtonId = '';
    let clickedButtonValue = '';
    if (event instanceof CustomEvent) {
      clickedButtonId = (event as CustomEvent).detail.id;
      clickedButtonValue = (event as CustomEvent).detail.value;
    } else {
      const element = event.currentTarget as HTMLButtonElement;
      clickedButtonId = element.id;
      clickedButtonValue = element.value;
    }
    if (this.chatSections.get(clickedButtonId) !== undefined) {
      this.setSocialTabContactForm(clickedButtonId, clickedButtonValue);
    }
  };

  public showSocialTabContactFormForButton(buttonId: string) {
    const element = document.getElementById(buttonId) as HTMLButtonElement;
    const buttonValue = element.value;
    this.setSocialTabContactForm(buttonId, buttonValue);
  }

  private setSocialTabContactForm(clickedButtonId: string, clickedButtonValue: string) {
    this.replaceSocialNetworkTemplateWithRealValue(clickedButtonId);
    this.socialForm.style.display = 'block';
    if (this.multipleSocialNetworks != null) {
      this.multipleSocialNetworks.style.display = 'none';
    }
    if (clickedButtonValue && clickedButtonValue.length > 0) this.submitSocialTabForm.value = clickedButtonValue;
    this.submitSocialTabForm.dataset.name = this.chatSections.get(clickedButtonId)!.name;
    this.submitSocialTabForm.dataset.section = this.chatSections.get(clickedButtonId)!.section;
  }

  public replaceSocialNetworkTemplateWithRealValue = (clickedButtonId: string) => {
    const buttonIdData = this.chatSections.get(clickedButtonId);
    if (buttonIdData !== undefined) {
      this.socialTabMessage.innerHTML = this.socialTabMessage.innerHTML.replace('{social_network}', buttonIdData.name);
    }
  };
}
